import { AnyAction } from 'redux';
import { ActionTypes } from './actions';
import ApplicationVersion from './ApplicationVersion';

export interface State {
	currentBuild: string | null;
	availableVersion: ApplicationVersion | null;
	dismissedBuild: string | null;
}

function createState(): State {
	return {
		currentBuild: null,
		availableVersion: null,
		dismissedBuild: null,
	};
}

export default function reducer(state: State = createState(), action: AnyAction): State {
	switch (action.type) {
		case ActionTypes.receive:
			if (state.availableVersion?.build === action.version?.build) {
				return state;
			}

			return { ...state, availableVersion: action.version };

		case ActionTypes.dismiss:
			return { ...state, dismissedBuild: action.build };

		default:
			return state;
	}
}

export function hasApplicationUpdate(state: State): boolean {
	const { currentBuild, availableVersion, dismissedBuild } = state;
	return Boolean(
		availableVersion && availableVersion.build !== currentBuild && availableVersion.build !== dismissedBuild
	);
}
